module.exports = __webpack_public_path__ + "static/img/net-border-6.b2f3e7bc.png";